import React, { Component } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { connect } from "react-redux";

// users
import avatar2 from "../../../assets/images/users/Default_User.png";

class ProfileMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: false,
      isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState((prevState) => ({
      menu: !prevState.menu,
    }));
  }
  render() {
    let username = "User";
    // let company = "Absolin";
    let avatar1 = avatar2;

    if (localStorage.getItem("User_full_name")) {
      username = localStorage.getItem("User_full_name").toUpperCase();
      // company = company.toUpperCase();
      // avatar1 = '../'+obj.data.userpic;
    }

    return (
      <React.Fragment>
        <Dropdown
          isOpen={this.state.menu}
          toggle={this.toggle}
          className=" user-dropdown"
        >
          <DropdownToggle
            tag="button"
            className="btn header-item waves-effect"
            id="page-header-user-dropdown"
          >
            <img
              className="rounded-circle header-profile-user mr-1"
              src={avatar1}
              alt="Header Avatar"
            />
          </DropdownToggle>
          <DropdownMenu right>
            <DropdownItem header>{username}</DropdownItem>
            {/* <DropdownItem href="/UserProfile">
              <i className="ri-user-line align-middle mr-2"></i> Profile
            </DropdownItem> */}
            <DropdownItem href="/ChangePassword">
              <i className="ri-lock-unlock-line align-middle mr-2"></i>
              Change Password
            </DropdownItem>
            {/* <DropdownItem header>{company}</DropdownItem> */}
            {!this.state.isMobile && (
              <>
                {this.props.userAccessList?.indexOf("System.change_settings") !==
                  -1 && (
                  <DropdownItem href="/SystemSettings">
                    <i className="ri-settings-3-line align-middle mr-2"></i>{" "}
                    System Settings
                  </DropdownItem>
                )}
                <DropdownItem divider />
                <DropdownItem href="/MastersDashboard">
                  <i className="ri-file-list-line align-middle mr-2"></i>{" "}
                  Masters
                </DropdownItem>
                {this.props.userAccessList?.indexOf("Users.add_user") !== -1 && (
                  <DropdownItem href="/Users">
                    <i className="ri-user-add-line align-middle mr-2"></i> Add
                    More Users
                  </DropdownItem>
                )}
              </>
            )}

            {/* <DropdownItem href="/Getcompany">
              <i className="ri-settings-2-line align-middle mr-2"></i> Company
              Settings
            </DropdownItem> */}
            {/* <DropdownItem text="true" href="#">
              <i className="ri-database-2-line align-middle mr-2"></i>{" "}
              Erase Databases
            </DropdownItem> */}
            <DropdownItem divider />
            <DropdownItem className="text-danger" href="/logout">
              <i className="ri-shut-down-line align-middle mr-2 text-danger"></i>{" "}
              Logout
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </React.Fragment>
    );
  }
}

// export default ProfileMenu;

const mapStatetoProps = (state) => {
  const { userAccessList } = state.Mini;
  return {
    userAccessList,
  };
};

export default connect(mapStatetoProps)(ProfileMenu);
